<template>
  <div>
    <div class="discountModule">
      <div class="discountCon">
        <!-- 限时秒杀 -->
        <div class="module module1" v-if="seckillList.length != 0">
          <div class="navBox" @click="jumpPage(1)">
            <div class="title1"><img class="img" src="/images/home/miao.png" alt="">
              <!-- <span v-if="seckillType == 0">(敬请期待)</span> -->
            </div>
            <div class="lineSplit" v-if="seckillType == 1 && (seckillInfo1 || seckillInfo2)"></div>
            <div class="timeBox" v-if="seckillType == 1 && (seckillInfo1 || seckillInfo2)">
              <div class="box1" :class="tabIndex == 1 ? 'check' : ''" v-if="seckillInfo1" @click="changeSeckill(1)">
                <div class="time">{{ seckillInfo1.startTime }}</div>
                <div class="countDown">
                  <el-statistic
                    :value="seckillInfo1.killFlag == 0 ? seckillInfo1.startCountDown : seckillInfo1.endCountDown"
                    format="HH:mm:ss" time-indices @finish="onFinish"
                    :title="seckillInfo1.killFlag == 0 ? '秒杀未开始' : '正在秒杀'">
                    <template slot="prefix">
                      <span class="word">{{ seckillInfo1.killFlag == 0 ? '距开始' : '距结束' }}</span>
                    </template>
                  </el-statistic>
                </div>
              </div>
              <div @click="changeSeckill(2)" style="display: flex;align-items: center;">
                <div class="box3" :class="tabIndex == 2 ? 'check' : ''" v-if="seckillInfo2">
                  <div class="time">{{ seckillInfo2.startTime }}</div>
                  <div class="lable">即将开始</div>
                </div>
                <div class="box3" :class="tabIndex == 2 ? 'check' : ''" v-else>
                  <div class="time">敬请期待</div>
                </div>
              </div>
            </div>
            <!-- <div class="more" @click="jumpPage(1)">
              <span class="word">更多</span>
              <img class="icon" src="/images/home/more1.png" alt="">
            </div> -->
          </div>
          <div class="goodBox">
            <div class="list">
              <div class="item" v-for="(item, i) in seckillList" :key="i" @click="jumpDetail(item, 1)">
                <img :src="item.mainImg" class="img" alt="">
                <div class="info">
                  <div class="name">{{ item.spuName }}</div>
                  <!-- <div class="lable">秒杀价</div> -->
                  <div class="box">
                    <div class="price">￥<span class="txt">{{ (Number(item.secondPrice) / 100).toFixed(2) }}</span></div>
                    <div class="price2">已售{{ item.saleCount }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 限量特惠 -->
        <div class="module module2" v-if="specialList.length != 0">
          <div class="navBox" @click="jumpPage(2)">
            <div class="title2"><img class="img" src="/images/home/limit.png" alt="">
              <!-- <span v-if="specialType == 0">(敬请期待)</span> -->
            </div>
            <div class="lineSplit" v-if="specialType == 1"></div>
            <div class="timeBox" v-if="specialType == 1">
              <div class="box1 box4 check ">
                <div class="countDown">
                  <el-statistic :value="specialInfo.countdown" format="HH:mm:ss" time-indices @finish="onFinish2">
                    <template slot="prefix">
                      <span class="word">距结束</span>
                    </template>
                  </el-statistic>
                </div>
              </div>
            </div>
            <!-- <div class="more" @click="jumpPage(2)">
              <span class="word">更多</span>
              <img class="icon" src="/images/home/more2.png" alt="">
            </div> -->
          </div>
          <div class="goodBox">
            <div class="list">
              <div class="item" v-for="(item, i) in specialList" :key="i" @click.stop="jumpDetail(item, 2)">
                <img :src="item.productSpu.picUrl" class="img" alt="">
                <div class="info">
                  <div class="name">{{ item.productSpu.name }}</div>
                  <!-- <div class="lable">特惠价</div> -->
                  <div class="box">
                    <div class="price">￥<span class="txt">{{ (Number(item.specialPrice) / 100).toFixed(2) }}</span>
                    </div>
                    <div class="price2">已售{{ item.saleCount }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 特价拼团 -->
        <div class="module module3">
          <div class="top" @click="jumpPage(3)">
            <div class="left">
              <img class="imgTit" src="/images/home/group.png" alt="">
            </div>
            <div class="right">
              <div class="tabBox">
                <!-- <div class="tabs">
                <div class="tab" v-for="(v, i) in groupTabs" :key="i" @click="changeGroup(v, i)">
                  <div class="word">{{ v.name }}</div>
                  <div class="line" :class="groupIndex == i ? 'line1' : 'line2'"></div>
                </div>
              </div> -->
                <!-- <div class="more" @click="jumpPage(3)">
                <span class="word">更多</span>
                <img class="icon" src="/images/home/more2.png" alt="">
              </div> -->
              </div>
            </div>
          </div>
          <div class="goods">
            <div class="out">
              <div class="list">
                <div class="item" v-for="(item, i) in groupList" :key="i" @click.stop="jumpDetail(item, 3)">
                  <img :src="item.mainImg" class="img" alt="">
                  <div class="info">
                    <div class="name">{{ item.name }}</div>
                    <div class="box1">
                      <!-- <div class="lable1">自营</div> -->
                      <div class="lable2" v-if="item.grouponSuccessType == 1">{{ item.lowestGroupNum }}人团</div>
                    </div>
                    <div class="box2">
                      <div class="price">￥<span class="txt">{{ (Number(item.singlePrice) / 100).toFixed(2) }}</span>
                      </div>
                      <div class="saleCount">已售{{ item.saleCount }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'discountModule',
  data() {
    return {
      deadline2: Date.now() + 1000 * 60 * 60 * 8,
      tabIndex: 1,
      seckillType: 1,
      seckillInfo1: '',
      seckillInfo2: '',
      seckillList: [],

      specialInfo: {},
      specialList: [],
      specialType: 1,

      groupTabs: [],
      groupIndex: 0,
      groupList: [],
      groupType: 0,

      list1: [{
        price: 3900,
        specialPrice: 3200,
        saleCount: 10,
        productSpu: {
          name: '味滋源 好久梅见桶装320g 蜜饯果干混合口味梅子青梅话梅休闲零食',
          picUrl: 'https://img13.360buyimg.com/n12/jfs/t1/241175/27/6789/231744/660a1245F14f539f8/f39335e6843acc95.jpg'
        }
      }, {
        price: 5757,
        specialPrice: 4899,
        saleCount: 10,
        productSpu: {
          name: '周黑鸭 好多肉肉礼盒500g 甜辣鸭舌鸭脖鸭掌 零食大礼包 真空独立小包',
          picUrl: 'https://img13.360buyimg.com/n12/jfs/t1/226925/28/3291/243556/6557583bF7eb63121/8ad77e28434c1bb1.png'
        }
      },
        // {
        //   price: 3656,
        //   specialPrice: 2986,
        //   saleCount: 10,
        //   productSpu: {
        //     name: '旺旺 零食大礼包 600g 混合袋装 休闲零食送女友礼物',
        //     picUrl: 'https://img13.360buyimg.com/n12/jfs/t1/223639/31/17932/195890/6375907bE62d4b60b/3d745d390c339395.jpg'
        //   }
        // }
      ],
      list2: [{
        salePrice: 3900,
        saleCount: 10,
        secondPrice: 3200,
        spuName: '味滋源 好久梅见桶装320g 蜜饯果干混合口味梅子青梅话梅休闲零食',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/241175/27/6789/231744/660a1245F14f539f8/f39335e6843acc95.jpg'
      }, {
        salePrice: 5757,
        saleCount: 10,
        secondPrice: 4899,
        spuName: '周黑鸭 好多肉肉礼盒500g 甜辣鸭舌鸭脖鸭掌 零食大礼包 真空独立小包',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/226925/28/3291/243556/6557583bF7eb63121/8ad77e28434c1bb1.png'
      },
        // {
        //   salePrice: 3656,
        //   saleCount: 10,
        //   secondPrice: 2986,
        //   spuName: '旺旺 零食大礼包 600g 混合袋装 休闲零食送女友礼物',
        //   mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/223639/31/17932/195890/6375907bE62d4b60b/3d745d390c339395.jpg'
        // }
      ],
      list3: [{
        marketPrice: 3900,
        saleCount: 10,
        groupPrice: 3200,
        singlePrice: 3200,
        name: '味滋源 好久梅见桶装320g 蜜饯果干混合口味梅子青梅话梅休闲零食',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/241175/27/6789/231744/660a1245F14f539f8/f39335e6843acc95.jpg'
      }, {
        marketPrice: 5757,
        saleCount: 10,
        groupPrice: 4899,
        singlePrice: 4899,
        name: '周黑鸭 好多肉肉礼盒500g 甜辣鸭舌鸭脖鸭掌 零食大礼包 真空独立小包',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/226925/28/3291/243556/6557583bF7eb63121/8ad77e28434c1bb1.png'
      },
        // {
        //   marketPrice: 3656,
        //   saleCount: 10,
        //   groupPrice: 2986,
        //   singlePrice: 2986,
        //   name: '旺旺 零食大礼包 600g 混合袋装 休闲零食送女友礼物',
        //   mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/223639/31/17932/195890/6375907bE62d4b60b/3d745d390c339395.jpg'
        // }
      ],
    };
  },

  mounted() {
    this.getSeckill()
    this.getSpecial()
    this.getGroup()
  },

  methods: {
    // 倒计时结束
    onFinish(val) {
      if (val) {
        this.getSeckill()
      }
    },
    onFinish2(val) {
      if (val) {
        this.getSpecial()
      }
    },
    // 切换秒杀场次
    changeSeckill(type) {
      if (type == this.tabIndex) {
        return
      }
      if (type == 2 && !this.seckillInfo2) {
        return
      }
      this.tabIndex = type
      if (type == 1) {
        this.seckillList = !this.seckillInfo1.data ? this.list2 : this.seckillInfo1.data
      } else {
        this.seckillList = !this.seckillInfo2.data ? this.list2 : this.seckillInfo2.data
      }
      this.$forceUpdate()
    },
    // 切换拼团活动
    changeGroup(v, i) {
      if (this.groupIndex == i) { return }
      this.groupIndex = i
      this.$loading()
      this.getGroupGoodsList(1)
    },
    // 查看更多
    jumpPage(type) {
      if (type == 1 && this.seckillType != 0) {
        this.$store.dispatch('saveSeckillInfo', '')
        this.$router.push({
          name: 'seckillList',
        })
      } else if (type == 2 && this.specialType != 0) {
        this.$store.dispatch('saveSpecialInfo', '')
        this.$router.push({
          name: 'specialList',
        })
      } else if (type == 3 && this.groupType != 0) {
        // this.$store.dispatch('saveGroupInfo', '')
        this.$router.push({
          name: 'groupList',
        })
      } else {
        return this.$message.warning('敬请期待')
      }
    },
    // 查看详情
    jumpDetail(item, type) {
      console.log(this.specialType);
      if ((type == 1 && this.seckillType == 0) || (type == 2 && this.specialType == 0) || (type == 3 && this.groupType == 0)) {
        return this.$message.warning('敬请期待')
      }
      if (type == 1) {
        this.$store.dispatch('saveGoodsId', item.spuId)
        this.$store.dispatch('saveModeType', 1)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "detail",
        });
      } else if (type == 2) {
        if (item.productSpu.productType == 1) {
          this.$store.dispatch('saveGoodsId', item.spuId)
          this.$store.dispatch('saveCategoryTitle', '')
          this.$store.dispatch('saveModeType', 1)
          this.$router.push({
            name: "jdDetail",
          });
        } else {
          this.$store.dispatch('saveGoodsId', item.spuId)
          this.$store.dispatch('saveModeType', 1)
          this.$store.dispatch('saveCategoryTitle', '')
          this.$router.push({
            name: "detail",
          });
        }
      } else {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$router.push({
          name: "groupDetail",
          // query: {
          //   id: item.id,
          // }
        });
      }

    },
    // 获取优惠活动信息
    getSpecial() {
      this.$api.mall.getSpecial().then((res) => {
        console.log(res, '限时特惠');
        if (res.code == 200) {
          if (!res.data) {
            this.specialType = 0
            this.specialList = this.list1
          } else {
            this.specialType = 1
            res.data.countdown = new Date(res.data.endTime).getTime() + 3000
            this.specialInfo = res.data
            this.specialList = !res.data.specialSpus ? this.list1 : res.data.specialSpus
          }
        }
        this.$forceUpdate()
      });
    },
    // 获取秒杀活动信息
    getSeckill() {
      this.$api.mall.getSeckill().then((res) => {
        console.log(res, '限时秒杀');
        if (res.code == 200) {
          if (!res.data || (res.data && res.data.length == 0)) {
            this.seckillList = this.list2
            this.seckillType = 0
          } else {
            this.skillType = 1
            let data = res.data
            data.forEach(item => {
              item.startCountDown = new Date(item.startTimeStamp).getTime() + 3000
              item.endCountDown = new Date(item.endTimeStamp).getTime() + 3000
            });
            this.seckillInfo1 = !res.data[0] ? '' : res.data[0]
            this.seckillInfo2 = !res.data[1] ? '' : res.data[1]

            this.seckillList = !res.data[0].data ? this.list2 : res.data[0].data
          }
        }
        this.$forceUpdate()
        this.$loading().close()
      });
    },
    // 获取拼团活动列表
    getGroup() {
      this.$api.mall.getGroupActivityList().then((res) => {
        if (res.code == 200) {
          if (!res.data || !res.data.length) {
            this.groupType = 0
            this.groupList = this.list3
            this.groupTabs = []
          } else {
            this.groupType = 1
            this.groupTabs = res.data
            this.getGroupGoodsList()
          }
        }
        this.$forceUpdate()
      });
    },
    // 获取拼团商品列表
    getGroupGoodsList(type) {
      this.$api.mall.getGroupGoodsList({
        pageNum: 1,
        pageSize: 8,
        groupId: this.groupTabs[this.groupIndex].id
      }).then((res) => {
        if (res.code == 200) {
          this.groupList = !res.rows ? [] : res.rows
        }
        this.$forceUpdate()
        if (type == 1) this.$loading().close()
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.discountModule {
  width: 100%;
  margin-top: 24px;

  .discountCon {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .module {
    width: 100%;
    border-radius: 10px;
    padding: 0 0 20px;
    box-sizing: border-box;

    .navBox {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 20px 14px;
      box-sizing: border-box;
      border-radius: 10px 10px 0 0;

      .title1 {
        font-weight: bold;
        font-size: 16px;
        color: #480800;
        display: flex;
        align-items: center;

        img {
          display: inline-block;
          width: 84px;
          height: 20px;
        }
      }

      .title2 {
        font-weight: bold;
        font-size: 16px;
        color: #C46F22;
        display: flex;
        align-items: center;

        img {
          display: inline-block;
          width: 90px;
          height: 20px;
        }
      }

      .lineSplit {
        width: 2px;
        height: 20px;
        background: #FFE4E4;
        margin-left: 9px;
      }

      .timeBox {
        flex: 1;
        padding: 0 32px 0 6px;
        box-sizing: border-box;
        display: flex;
        text-align: left;

        .box1 {
          height: 40px;
          padding: 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .time {
            font-size: 16px;
            font-weight: bold;
          }

          .countDown {
            flex: 1;

            .word {
              font-size: 12px;
              color: #000000;
            }

            ::v-deep .number {
              font-size: 12px;
              color: #000000;
            }

            ::v-deep .head {
              text-align: left;
            }

            ::v-deep .title {
              font-size: 12px;
              color: #000000;
            }

            ::v-deep .el-statistic {
              display: flex;
              align-items: center;

              .head {
                margin-bottom: 0;
              }
            }
          }
        }

        .box2 {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #e01121 50%, #ffffff 50%);
        }

        .box2_2 {
          width: 40px;
          height: 40px;
          background: linear-gradient(-45deg, #e01121 50%, #ffffff 50%);
        }

        .box3 {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #410B00;

          .time {
            font-size: 16px;
          }

          .lable {
            border-radius: 20px;
            font-size: 16px;
            color: #410B00;
            padding: 3px 10px;
            box-sizing: border-box;
            margin-left: 10px;
          }
        }

        .box4 {
          padding: 0;
          color: #C46F22 !important;

          .countDown {
            .word {
              color: #C46F22 !important;
            }

            ::v-deep .number {
              color: #C46F22 !important;
            }

            ::v-deep .title {
              color: #C46F22 !important;
            }
          }
        }

        .check {
          font-size: 16px;
          color: #410B00;

          .countDown {
            .word {
              font-size: 16px;
              color: #410B00;
            }

            ::v-deep .number {
              font-size: 16px;
              color: #410B00;
            }

            ::v-deep .head {
              text-align: left;
            }

            ::v-deep .title {
              font-size: 16px;
              color: #410B00;
            }
          }

          .lable {
            border-color: #fff;
            color: #fff;
          }
        }
      }

      .more {
        display: flex;
        align-items: center;

        .word {
          color: #904747;
          border-radius: 10px;
          font-weight: bold;
          margin-right: 5px;
        }

        .icon {
          width: 14px;
          height: 14px;
        }
      }
    }

    .goodBox {
      width: 100%;
      overflow: hidden;

      .list {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fill, 50%);
        justify-content: space-between;
        box-sizing: border-box;
        display: flex;
        padding: 0 20px;
        grid-column-gap: 10px;

        .item {
          width: calc(50% - 10px);
          box-sizing: border-box;

          .img {
            width: 100%;
            height: 166px;
            border-radius: 8px;
          }

          .info {
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-top: 20px;

            .name {
              width: 100%;
              font-size: 14px;
              color: #333333;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              word-break: break-all;
            }

            .lable {
              width: 40px;
              height: 16px;
              background: linear-gradient(90deg, #18D5FE 0%, #2D80FF 100%);
              border-radius: 2px;
              font-size: 12px;
              color: #FFFFFF;
              line-height: 16px;
              text-align: center;
            }

            .box {
              width: 100%;
              display: flex;
              align-items: center;
              margin-top: 10px;

              .price {
                font-size: 16px;
                color: #FF1D18;
                font-weight: bold;

                .txt {
                  font-size: 20px;
                }
              }

              .price2 {
                font-size: 12px;
                color: #999999;
                margin-left: 8px;
              }
            }
          }
        }
      }
    }
  }

  .module1 {
    background: linear-gradient(180deg, #FFE5E4 0%, #FFFCFC 100%);

    .navBox {}
  }

  .module2 {
    background: linear-gradient(180deg, #FBEED0 0%, #FFFCF5 100%);

    .navBox {

      .more {
        .word {
          color: #C46F22;
        }
      }
    }
  }

  .module3 {
    width: 100%;
    background: linear-gradient(180deg, #EBDFFF 0%, #FAF7FF 100%);
    overflow: hidden;
    box-sizing: border-box;

    .top {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-between;

      .left {
        padding: 20px 20px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .imgIcon {
          width: 32px;
        }

        .imgTit {
          width: 85px;
          height: 20px;
        }
      }

      .right {
        display: flex;
        align-items: center;

        .tabBox {
          width: 100%;
          height: 62px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 0 10px 0 10px;
          padding: 0 12px;
          box-sizing: border-box;
          overflow: hidden;

          .tabs {
            flex: 1;
            padding: 0 24px;
            box-sizing: border-box;
            display: flex;
            align-items: center;

            .tab {
              padding: 0 24px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;

              .word {
                font-size: 20px;
                font-weight: bold;
                color: #ff0000;
                line-height: 40px;
              }

              .line {
                width: 100px;
                height: 3px;
                border-radius: 5px;
              }

              .line1 {
                background-color: #ff0000;
              }

              .line2 {
                background-color: transparent;
              }
            }
          }

          .more {
            display: flex;
            align-items: center;

            .word {
              font-size: 14px;
              color: #C23E3E;
              margin-right: 5px;
            }

            .icon {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }

    .goods {
      width: 100%;
      margin-top: 14px;

      .out {
        width: 100%;
        height: 100%;

        .list {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          justify-content: space-between;
          padding: 0 20px;

          .item {
            width: 100%;
            box-sizing: border-box;

            .img {
              width: 100%;
              height: 166px;
              border-radius: 7px;
            }

            .info {
              width: 100%;
              // height: 50px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .name {
                width: 100%;
                height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                word-break: break-all;
                font-size: 14px;
                color: #333333;
                margin-top: 20px;
              }

              .box1 {
                width: 100%;
                display: flex;
                align-items: center;
                padding: 5px 0 8px;
                box-sizing: border-box;

                .lable1 {
                  width: 28px;
                  height: 16px;
                  line-height: 16px;
                  background: linear-gradient(90deg, #18D5FE 0%, #2D80FF 100%);
                  border-radius: 2px;
                  font-size: 12px;
                  color: #ffffff;
                  text-align: center;
                }

                .lable2 {
                  width: 46px;
                  background-color: #ff6f11;
                  border-radius: 3px;
                  font-size: 14px;
                  color: #ffffff;
                  text-align: center;
                  margin-left: 10px;
                }
              }

              .box2 {
                width: 100%;
                display: flex;
                align-items: center;

                .price {
                  font-size: 16px;
                  color: #FF1D18;


                  .txt {
                    font-size: 20px;
                    font-weight: bold;
                  }
                }

                .saleCount {
                  font-size: 12px;
                  color: #999999;
                  margin-left: 8px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>